"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** Global Class  */
window.FAB_METABOX_SETTING = Object.assign(Object.assign({}, window.FAB_METABOX_SETTING), { 
    /**
     * Define Default Option
     * */
    defaultOptions: Object.assign(Object.assign({}, window.FAB_METABOX_SETTING.defaultOptions), { select2: { placeholder: '--choose--' } }), 
    /** Init */
    init: () => {
        /** Initiate Select2 */
        jQuery('.fab-container.metabox-settings .select2').select2();
        window.FAB_METABOX_SETTING.initTypeOptions();
        window.FAB_METABOX_SETTING.initHotkeyOptions();
        jQuery(document).ready(function ($) {
            // Initialize WooCommerce features
            window.FAB_METABOX_SETTING.initWooCommerceFeaturedProduct();
            window.FAB_METABOX_SETTING.initWooCommerceApplyCoupon();
            // Trigger event listener for select2 change
            jQuery('#field_fab_setting_type').on('change.select2', window.FAB_METABOX_SETTING.triggerTypeChange);
        });
    }, 
    /**
     * Init select2 type
     * */
    initTypeOptions: () => {
        let dom = jQuery('#field_fab_setting_type');
        if (dom) {
            let options = [];
            if (dom.data('select2'))
                dom.select2('destroy');
            /** Map Types */
            const types = window.FAB_METABOX_SETTING.defaultOptions.types;
            options = types.map((type) => ({
                text: type.text,
                children: type.children.map((child) => ({
                    id: child.id,
                    text: child.text,
                    disabled: child.is_enable === false, // Disable option if is_enable is false
                })),
            }));
            /** Init jQuery Select2 */
            dom.select2({
                placeholder: '--choose--',
                data: options,
            });
            if (dom.data('selected')) {
                dom.val(dom.data('selected'));
                dom.trigger('change');
            }
        }
    }, 
    /**
     * Init select2 hotkey
     * */
    initHotkeyOptions: () => {
        let dom = jQuery('#field_fab_setting_hotkey');
        if (dom) {
            let options = [{ id: 'none', text: 'None' }];
            if (dom.data('select2'))
                dom.select2('destroy');
            /** Map Function Key */
            for (let i = 1; i <= 12; i++) {
                options.push({ id: `f${i}`, text: `F${i}` });
            }
            for (let i = 1; i <= 12; i++) {
                options.push({ id: `shift+f${i}`, text: `Shift+F${i}` });
            }
            for (let i = 1; i <= 12; i++) {
                options.push({ id: `alt+f${i}`, text: `Alt+F${i}` });
            }
            /** Map Special Key */
            let specialKey = ['esc', 'tab', 'space', 'return', 'backspace', 'insert', 'home', 'del', 'end', 'pageup', 'pagedown', 'left', 'up', 'right', 'down'];
            specialKey.forEach((i) => { options.push({ id: `ctrl+${i}`, text: `Ctrl+${i}` }); });
            specialKey.forEach((i) => { options.push({ id: `shift+${i}`, text: `Shift+${i}` }); });
            specialKey.forEach((i) => { options.push({ id: `alt+${i}`, text: `Alt+${i}` }); });
            /** Map CTRL, Shift, Alt Alphabetically */
            for (let i = 65; i <= 90; i++) {
                options.push({ id: `ctrl+${String.fromCharCode(i)}`, text: `Ctrl+${String.fromCharCode(i)}` });
            }
            for (let i = 65; i <= 90; i++) {
                options.push({ id: `shift+${String.fromCharCode(i)}`, text: `Shift+${String.fromCharCode(i)}` });
            }
            for (let i = 65; i <= 90; i++) {
                options.push({ id: `alt+${String.fromCharCode(i)}`, text: `Alt+${String.fromCharCode(i)}` });
            }
            /** Init jQuery Select2 */
            dom.select2({ placeholder: '--choose--', data: options });
            if (dom.data('selected')) {
                dom.val(dom.data('selected'));
                dom.trigger('change');
            }
        }
    }, 
    /**
     * Init WooCommerce Featured Product Select
     * */
    initWooCommerceFeaturedProduct: () => {
        let dom = jQuery('#field_fab_setting_featured_product');
        if (dom) {
            // Destroy any existing Select2 instance
            if (dom.data('select2'))
                dom.select2('destroy');
            // Initialize Select2 with AJAX search
            jQuery('#field_fab_setting_featured_product').select2({
                placeholder: '--choose--',
                allowClear: true,
                minimumInputLength: 2,
                ajax: {
                    url: '/wp-admin/admin-ajax.php',
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            action: 'fab_search_products',
                            q: params.term, // Pass the search term typed by the user
                        };
                    },
                    processResults: function (data) {
                        // Process the response and return the results in the format Select2 expects
                        return {
                            results: data.map(function (product) {
                                return {
                                    id: product.id,
                                    text: product.text,
                                };
                            }),
                        };
                    },
                    cache: true, // Cache the results to avoid making the same request multiple times
                },
            });
            // Default value.
            const selectedValue = jQuery('#field_fab_setting_featured_product').data('selected');
            if (selectedValue) {
                const [id, ...rest] = selectedValue.split('-');
                // Join the rest of the string as the text, maintaining the original hyphens
                const text = rest.join('-').trim();
                // Manually set the selected value and trigger the change event
                jQuery('#field_fab_setting_featured_product').select2('trigger', 'select', {
                    data: { id: id, text: text }
                });
                jQuery('#field_fab_setting_featured_product').val(id).trigger('change');
            }
        }
    }, 
    /**
     * Init WooCommerce Apply Coupon Select
     * */
    initWooCommerceApplyCoupon: () => {
        let dom = jQuery('#field_fab_setting_apply_coupon');
        if (dom) {
            // Destroy any existing Select2 instance
            if (dom.data('select2'))
                dom.select2('destroy');
            // Initialize Select2 with AJAX search for coupons
            jQuery('#field_fab_setting_apply_coupon').select2({
                placeholder: '--choose--',
                allowClear: true,
                minimumInputLength: 2,
                ajax: {
                    url: '/wp-admin/admin-ajax.php',
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            action: 'fab_search_coupons',
                            q: params.term, // Pass the search term typed by the user
                        };
                    },
                    processResults: function (data) {
                        // Process the response and return the results in the format Select2 expects
                        return {
                            results: data.map(function (coupon) {
                                return {
                                    id: coupon.id,
                                    text: coupon.text,
                                };
                            }),
                        };
                    },
                    cache: true, // Cache the results to avoid making the same request multiple times
                },
            });
            // Default value for the selected coupon.
            const selectedValue = jQuery('#field_fab_setting_apply_coupon').data('selected');
            if (selectedValue) {
                const [id, ...rest] = selectedValue.split('-');
                // Join the rest of the string as the text, maintaining the original hyphens
                const text = rest.join('-').trim();
                // Manually set the selected value and trigger the change event
                jQuery('#field_fab_setting_apply_coupon').select2('trigger', 'select', {
                    data: { id: id, text: text }
                });
                jQuery('#field_fab_setting_apply_coupon').val(id).trigger('change');
            }
        }
    }, 
    /** Setting Type Event Change
     * Hide open in new window if type is not link
     */
    triggerTypeChange(el) {
        window.FAB_METABOX_SETTING.data.fab.type = el.target.value;
        jQuery('#fab_setting_type_update').click();
        jQuery(document).ready(function ($) {
            if (el.target.value === 'featured_product') {
                window.FAB_METABOX_SETTING.initWooCommerceFeaturedProduct();
            }
            else if (el.target.value === 'apply_coupon') {
                window.FAB_METABOX_SETTING.initWooCommerceApplyCoupon();
            }
        });
    } });
